import styled, { css } from 'styled-components';
import { StyledButtonIconProps } from './types';

export const StyledButtonIcon = styled.button.attrs((props: StyledButtonIconProps) => ({
  type: 'button',
  ...props
}))<StyledButtonIconProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${props => {
    switch (props.size) {
      case 'small':
        return '8px';
      case 'medium':
        return '12px';
      default:
        return '16px';
    }
  }};
  border-radius: 2px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  gap: 8px;
  min-width: ${props => props.onlyIcon ? '40px' : '80px'};
  height: 40px;
  
  ${props => {
    switch (props.buttonType) {
      case 'primary':
        return css`
          background-color: var(--color-action-default) !important;
          color: var(--color-contrast-brand) !important;
          border: none;

          &:hover {
            background-color: var(--color-action-hover) !important;
          }
        `;
      case 'danger':
        return css`
          background-color: var(--color-feedback-danger-300);
          color: var(--color-contrast-white);
          
          &:hover {
            background-color: #eb140c;
          }
        `;
      case 'secondary':
        return css`
          background-color: var(--color-opacity-default);
          color: var(--color-neutral-600);
          border: var(--border-width-default) solid var(--color-neutral-600);

          &:hover, &:active {
            &:not(:disabled) {
              background-color: var(--color-opacity-hover);
            }
          }
        `;
      case "tertiary":
        return css`
          background-color: var(--color-neutral-100);
          color: #496072;;
          border: solid 1px #c5d0e1;
          
          &:hover {
            background-color: #f4f5f8;
            border: solid 1px #c5d0e1;
          }
        `;
      case 'hidden':
        return css`
          background-color: transparent;
          color: var(--color-neutral-600);
          border: none;

          &:hover {
            background-color: rgba(0, 0, 0, 0.04) !important;
          }
        `;
      case 'default':
      default:
        return css`
          background-color: var(--color-opacity-default);
          color: var(--color-neutral-600);
          border: var(--border-width-default) solid var(--color-neutral-600);
          
          &:hover, &:active {
            &:not(:disabled) {
              background-color: rgba(0, 0, 0, 0.04) !important;
            }
          }
        `;
    }
  }}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed !important;
  }
  
  .button-content {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .button-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .button-text {
    font-size: 14px;
    font-weight: var(--font-weight-semibold);
  }
`;


